import React from "react";

import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import LineChart from "./components/charts/LineChart";
import BarChart from "./components/charts/BarChart";
import PieChart from "./components/charts/PieChart";
import ColumnChart from "./components/charts/ColumnChart";
import TableMaster from "./components/charts/TableMaster";
import SelectMultiple from "./components/SelectMultiple";
import SelectYear from "./components/SelectYear";
import Download from "./components/Download";
import {
  Card,
  CardBody,
  CardFooter,
  Row,
  Col
} from "reactstrap";
import dataServer from "./components/dataServer";
import dataOefa, {
  denuncia_tipo_medio,
  denuncia_tipo_fuente,
  denuncia_periodo,
  denuncia_mes,
  denuncia_tabla,
  denuncia_total,
  denuncia_region,
  denuncia_sector
} from "./components/dataOefa";
const default_param = [
  { value: "00", label: "NACIONAL" },
  { value: 2019, label: 2019 }
];
let mdx = [];
let last={};
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      regions: [default_param[0]],
      region_code: default_param[0].value,
      year: default_param[1].value,
      param_regiones: default_param[0].label,
      param_periodo: default_param[1].value,
      last_month: "",
      ndx: [],
      data_tipo_medio: [],
      data_tipo_fuente: [],
      data_denuncia_periodo: [],
      data_denuncia_mes: [],
      data_denuncia_tabla: [],
      data_denuncia_region: [],
      data_denuncia_sector: [],
      param_total: denuncia_total
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeYear = this.handleChangeYear.bind(this);
    this.loadDataOK = this.loadDataOK.bind(this);
  }
  componentDidMount() {
    let me = this;
    dataServer(function (data) {
      mdx = data;
      last=mdx.last;
      dataOefa(mdx, [default_param[0]], default_param[1].value);
      me.loadDataOK();
    });
  }
  loadDataOK() {
    this.setState({
      data_tipo_medio: denuncia_tipo_medio,
      data_tipo_fuente: denuncia_tipo_fuente,
      data_denuncia_periodo: denuncia_periodo,
      data_denuncia_mes: denuncia_mes,
      data_denuncia_tabla: denuncia_tabla,
      data_denuncia_region: denuncia_region,
      data_denuncia_sector: denuncia_sector,
      param_total: denuncia_total,
      last_month:last[new Date().getFullYear()]
    });
  }
  handleChange(regions) {
    dataOefa(mdx, regions, this.state.year);
    let label_regiones = "";
    let code_region = "";
    if (regions) {
      regions.map(function (item) {
        label_regiones =
          label_regiones === ""
            ? item.label
            : label_regiones + ", " + item.label;
        code_region = item.value;
      });
    }
    this.setState({
      region_code: code_region,
      param_regiones: label_regiones,
      regions: regions,
      data_tipo_medio: denuncia_tipo_medio,
      data_tipo_fuente: denuncia_tipo_fuente,
      data_denuncia_periodo: denuncia_periodo,
      data_denuncia_mes: denuncia_mes,
      data_denuncia_tabla: denuncia_tabla,
      data_denuncia_region: denuncia_region,
      data_denuncia_sector: denuncia_sector,
      param_total: denuncia_total
    });
  }
  handleChangeYear(e) {
    dataOefa(mdx, this.state.regions, e);
    this.setState({
      year: e,
      param_periodo: e,
      data_tipo_medio: denuncia_tipo_medio,
      data_tipo_fuente: denuncia_tipo_fuente,
      data_denuncia_periodo: denuncia_periodo,
      data_denuncia_mes: denuncia_mes,
      data_denuncia_tabla: denuncia_tabla,
      data_denuncia_sector: denuncia_sector,
      param_total: denuncia_total,
      data_denuncia_region: denuncia_region,
      last_month:last[e]
    });
  }
  render() {
    const {
      data_tipo_medio,
      data_tipo_fuente,
      data_denuncia_mes,
      data_denuncia_tabla,
      data_denuncia_region,
      data_denuncia_sector,
      param_periodo,
      param_regiones,
      param_total,
      last_month
    } = this.state;
    return (
      <div className="container-fluid">
        <Row className="card-top">
          <Col md={12} xs={12}>
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col md={5} xs={5}>
                    <p className="bg-white text-dark text-justify ">
                      Para el año{" "}
                      <span className="text-danger text-acumulado">
                        {param_periodo}{" "}
                      </span>
                      se contabiliza un total de{" "}
                      <span className="text-danger text-acumulado">
                        {param_total} denuncias ambientales{" "}
                      </span>
                      en el ámbito que comprende a{" "}
                      <span className="text-danger text-acumulado">
                        {param_regiones}
                        {", "}
                      </span>
                      a través del Servicio Nacional de Denuncias Ambientales -
                      SINADA, unidad especializada del Oganismo de Evaluación y
                      Fiscalización Ambiental - OEFA.
                    </p>
                  </Col>
                  <Col md={4} xs={4}>
                    Seleccion uno/varios ámbitos
                    <SelectMultiple onChange={this.handleChange} />
                  </Col>
                  <Col md={2} xs={2}>
                    Seleccione un Año
                    <SelectYear onChange={this.handleChangeYear} />
                  </Col>
                  <Col md={1} xs={1}>
                    Imprimir
                    <a
                      href="#"
                      onClick={() => window.print()}
                      className="btn btn-success"
                    >
                      <span className="glyphicon glyphicon-print" />
                    </a>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter />
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md={12} xs={12}>
            <Card className="card-stats">
              <CardBody>
                <Tabs>
                  <TabList>
                    <Tab>Líneas</Tab>
                    <Tab>Columnas</Tab>
                  </TabList>
                  <TabPanel>
                    <LineChart
                      datos={data_denuncia_mes.datos}
                      category={data_denuncia_mes.category}
                      title={
                        "Denuncias ambientales registradas en el " +
                        `${param_periodo}`
                      }
                      titley="Número"
                    />
                  </TabPanel>
                  <TabPanel>
                    <ColumnChart
                      datos={data_denuncia_mes.datos}
                      category={data_denuncia_mes.category}
                      title={
                        "Denuncias ambientales registradas en el " +
                        `${param_periodo}`
                      }
                      titley="Número"
                      type="1"
                    />
                  </TabPanel>
                </Tabs>
              </CardBody>
              <CardFooter>
                Fuente : OEFA, {last_month} {param_periodo}{" "}
                <a
                  href="http://datosabiertos.oefa.gob.pe/dataviews/250325/denuncias-sinada/"
                  className="btn btn-link"
                  role="button"
                  aria-pressed="true"
                  target="_blank"
                >
                  <span className="text-primary">Ir a la fuente</span>
                </a>
              </CardFooter>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md={6} xs={6}>
            <Card className="card-stats">
              <CardBody>
                <BarChart
                  datos={data_denuncia_region.datos}
                  category={data_denuncia_region.category}
                  title={
                    "Denuncias ambientales registradas por departamentos en el" +
                    `${param_periodo}`
                  }
                  titley="Número"
                  type="2"
                />
              </CardBody>
              <CardFooter>
                Fuente : OEFA, {last_month} {param_periodo}{" "}
                <a
                  href="http://datosabiertos.oefa.gob.pe/dataviews/250325/denuncias-sinada/"
                  className="btn btn-link"
                  role="button"
                  aria-pressed="true"
                  target="_blank"
                >
                  <span className="text-primary">Ir a la fuente</span>
                </a>
              </CardFooter>
            </Card>
          </Col>
          <Col md={6} xs={6}>
            <Card className="card-stats">
              <CardBody>
                <BarChart
                  datos={data_denuncia_sector.datos}
                  category={data_denuncia_sector.category}
                  title={
                    "Denuncias ambientales registradas por sector en el " +
                    `${param_periodo}`
                  }
                  titley="Número"
                  type="2"
                />
              </CardBody>
              <CardFooter>
                Fuente : OEFA, {last_month} {param_periodo}{" "}
                <a
                  href="http://datosabiertos.oefa.gob.pe/dataviews/250325/denuncias-sinada/"
                  className="btn btn-link"
                  role="button"
                  aria-pressed="true"
                  target="_blank"
                >
                  <span className="text-primary">Ir a la fuente</span>
                </a>
              </CardFooter>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md={6} xs={6}>
            <Card className="card-stats">
              <CardBody>
                <PieChart
                  datos={data_tipo_medio}
                  title={
                    "Denuncias ambientales registradas por medio afectado en el " + `${param_periodo}`
                  }
                />
              </CardBody>
              <CardFooter>
                Fuente : OEFA, {last_month} {param_periodo}{" "}
                <a
                  href="http://datosabiertos.oefa.gob.pe/dataviews/250325/denuncias-sinada/"
                  className="btn btn-link"
                  role="button"
                  aria-pressed="true"
                  target="_blank"
                >
                  <span className="text-primary">Ir a la fuente</span>
                </a>
              </CardFooter>
            </Card>
          </Col>
          <Col md={6} xs={6}>
            <Card className="card-stats">
              <CardBody>
                <PieChart
                  datos={data_tipo_fuente}
                  title={
                    "Denuncias ambientales registradas por tipos de fuentes en el" + `${param_periodo}`
                  }
                />
              </CardBody>
              <CardFooter>
                Fuente : OEFA, {last_month} {param_periodo}{" "}
                <a
                  href="http://datosabiertos.oefa.gob.pe/dataviews/250325/denuncias-sinada/"
                  className="btn btn-link"
                  role="button"
                  aria-pressed="true"
                  target="_blank"
                >
                  <span className="text-primary">Ir a la fuente</span>
                </a>
              </CardFooter>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col md={12} xs={12}>
            <Card className="card-stats">
              <CardBody>
                <Download datos={data_denuncia_tabla} />
                <TableMaster
                  page_size={data_denuncia_tabla.length}
                  rows={data_denuncia_tabla}
                  title="Lista de Denuncias Recibidas"
                />
              </CardBody>
              <CardFooter>
                Fuente : OEFA, {last_month} {param_periodo}{" "}
                <a
                  href="http://datosabiertos.oefa.gob.pe/dataviews/250325/denuncias-sinada/"
                  className="btn btn-link"
                  role="button"
                  aria-pressed="true"
                  target="_blank"
                >
                  <span className="text-primary">Ir a la fuente</span>
                </a>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default App;
